// import Vue from 'vue'
// import Vuex from 'vuex'
import login from './modules/login'
import doctor from './modules/doctor'
import managerPlanList from './modules/managerPlanList'
import managerPlan from './modules/managerPlan'
import managerUser from'./modules/managerUser'
import newtask from './modules/newtask'
import supervisor from './modules/supervisor'
import breadcrumb from './modules/breadcrumb'
import admin from './modules/admin'
import visualization from './modules/visualization'
import centralStatistics from './modules/centralStatistics'
import dataExport from './modules/dataExport'

Vue.use(Vuex)

export default new Vuex.Store({
  modules:{
    login,
    doctor,
    managerPlanList,
    managerPlan,
    managerUser,
    newtask,
    supervisor,
    breadcrumb,
    admin,
    visualization,
    centralStatistics,
    dataExport
  }
})
